
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/culture",
      function () {
        return require("private-next-pages/culture.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/culture"])
      });
    }
  